import '../styles/PageGlobal.css';
import './ProduitNewPage.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReferenceButton from '../components/ReferenceButton';
import { ProductService } from '../services/ProductService';

export default function ProduitNewPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    refFabricant:    '',
    refInterne:      '',
    designation:     '',
    description:     '',
    capacite:        '',
    typeDeproduit:   '',
    categories:      '',
    sousCategories:  '',
    uniteDeMesure:   '',
    pa:              '',
    pv:              '',
    ecoparticipation:'',
    deee:            '',
    coutDeRevient:   '',
    ean:             '',
    hscod:           '',
    photos:          '',
    poids:           '',
    longueur:        '',
    largeur:         '',
    hauteur:         '',
    poidsVolume:     '',
    garantie:        '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  // ── Field change handler ────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // ── Submit handler (Real Backend Call) ──────────────────────────────────────
  const handleSubmit = async () => {
    const produitService = new ProductService();
    setLoading(true);
    setError(null);
    try {
      await produitService.createProduct(form);
      alert('Produit créé avec succès !');
      navigate('/product_list');
    } catch (err) {
      console.error('Error créer produit:', err);
      setError(err.message || 'Erreur lors de la création du produit');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/product_list');
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="containerMain produit-new-container">
      <h1 className="produit-new-title">Créer un Produit</h1>
      <p>Ceci est un contenu protégé</p>

      {error && <div className="produit-new-error">{error}</div>}

      <div className="produit-new-form">

        {/* ── Part 1 ── */}
        <div className="produit-new-section-title">Informations générales</div>

        <div className="produit-new-row">
          <label>REF FABRICANT</label>
          <input name="refFabricant" value={form.refFabricant} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>REF INTERNE</label>
          <input name="refInterne" value={form.refInterne} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>DESIGNATION</label>
          <input name="designation" value={form.designation} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>DESCRIPTION</label>
          <textarea name="description" value={form.description} onChange={handleChange} rows={3} />
        </div>
        <div className="produit-new-row">
          <label>CAPACITE</label>
          <input name="capacite" value={form.capacite} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>TYPE DE PRODUIT</label>
          <input name="typeDeproduit" value={form.typeDeproduit} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>CATEGORIES</label>
          <input name="categories" value={form.categories} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>SOUS CATEGORIES</label>
          <input name="sousCategories" value={form.sousCategories} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>UNITE DE MESURE</label>
          <input name="uniteDeMesure" value={form.uniteDeMesure} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>PA</label>
          <input name="pa" value={form.pa} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>PV</label>
          <input name="pv" value={form.pv} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>ECOPARTICIPATION</label>
          <input name="ecoparticipation" value={form.ecoparticipation} onChange={handleChange} />
        </div>

        {/* ── Part 2 ── */}
        <div className="produit-new-section-title">Détails techniques</div>

        <div className="produit-new-row">
          <label>DEEE</label>
          <input name="deee" value={form.deee} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>COUT DE REVIENT</label>
          <input name="coutDeRevient" value={form.coutDeRevient} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>EAN</label>
          <input name="ean" value={form.ean} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>HSCOD</label>
          <input name="hscod" value={form.hscod} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>PHOTOS</label>
          <input name="photos" value={form.photos} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>POIDS</label>
          <input name="poids" value={form.poids} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>LONGUEUR</label>
          <input name="longueur" value={form.longueur} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>LARGEUR</label>
          <input name="largeur" value={form.largeur} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>HAUTEUR</label>
          <input name="hauteur" value={form.hauteur} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>POIDS / VOLUME</label>
          <input name="poidsVolume" value={form.poidsVolume} onChange={handleChange} />
        </div>
        <div className="produit-new-row">
          <label>GARANTIE</label>
          <input name="garantie" value={form.garantie} onChange={handleChange} />
        </div>

        {/* ── Actions ── */}
        <div className="produit-new-actions">
          <ReferenceButton onClick={handleCancel}>Annuler</ReferenceButton>
          <ReferenceButton onClick={handleSubmit} style={{ opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Enregistrement…' : 'Créer'}
          </ReferenceButton>
        </div>

      </div>
    </div>
  );
}